import type { EventStarterBuildingGrant } from "@/types";

/**
 * Resolved starter grants for cleanup/grants.
 * Prefer overview slice from BE; fall back to event attributes when partial.
 */
export function getStarterBuildingGrants(params: {
	startBuildingClaims?: ReadonlyArray<EventStarterBuildingGrant> | null;
	overviewGrants?: ReadonlyArray<EventStarterBuildingGrant> | null;
}): Array<EventStarterBuildingGrant> {
	if (params.overviewGrants?.length) {
		return [...params.overviewGrants];
	}

	const explicit = params.startBuildingClaims;
	if (explicit?.length) {
		return [...explicit];
	}

	return [];
}
